import { collectionEngine } from '../apis.js';
const req = collectionEngine('/preview');
const genEmailPreviewUrl = (caseId, data) => {
    return `/email?content=${encodeURIComponent(JSON.stringify({ data, caseId }))}`;
};
export const getPreview = (caseId, data) => req('GET', genEmailPreviewUrl(caseId, data));
//# sourceMappingURL=preview.js.map